<template>
  <DataTable :value="auditsDataAfficher" rowGroupMode="subheader" groupRowsBy="ecranDescription" sortMode="single"
             resizableColumns columnResizeMode="expand"
             sortField="ecranDescription" :sortOrder="1" scrollable scrollHeight="890px" tableStyle="min-width: 50rem">
    <Column field="ecranDescription" header="Écran"></Column>
    <Column field="roleNom" header="Rôle" style="min-width: 350px">
      <template #body="slotProps">
        {{
          afficheRolePrecedent(slotProps.data.roleNom)
        }}
      </template>
    </Column>
    <Column field="roleDescription" header="Description" style="min-width: 200px">
      <template #body="slotProps">
        {{
          afficheRoleDescriptionPrecedent(slotProps.data.roleDescription)
        }}
      </template>
    </Column>
    <Column field="roleAdministrer" header="Attr." style="min-width: 200px">
      <template #body="slotProps">
        {{
          afficheRoleAdministrerPrecedent(slotProps.data.roleAdministrer)
        }}
      </template>
    </Column>
    <Column field="action" header="Changements" style="min-width: 1000px">
      <template #body="slotProps">
        {{ formatAction(slotProps.data.action) }}
        {{ $commun.formatDateHeure(slotProps.data.justification.modifierLe) }}
        Par :
        {{ slotProps.data.justification.modifierParAffichage }}

        <div v-if="slotProps.data.justification.justificationFichier.length > 0">
          <DataTable
              class="p-datatable-sm"
              :value="slotProps.data.justification.justificationFichier"
              :resizableColumns="true"
              columnResizeMode="fit"
              :reorderableColumns="true"
              sortField="cle"
              :sortOrder="-1"
              responsiveLayout="scroll"
              :scrollableY="true"
              scrollHeight="500px"
              dataKey="cle"
          >
            <Column
                field="description"
                header="Description"
                :sortable="true"
                class="table-txt-wrap"
                @click="onSelect"
            >
              <template #body="slotProps">
                <label class="hyperlink underline"
                       @click="onSelect(slotProps.data)">{{ slotProps.data.description }}</label>
              </template>
            </Column>
            <Column
                field="creerPar"
                header="Créé Par"
                :sortable="true"
                class="table-txt-wrap"
            ></Column>
            <Column
                field="creerLe"
                header="Date de création"
                :sortable="true"
                class="table-txt-wrap"
            >
              <template #body="slotProps">
                {{
                  $commun.formatDateHeure(
                      slotProps.data.creerLe
                  )
                }}
              </template>
            </Column>
          </DataTable>
        </div>
      </template>

    </Column>
    <template #groupheader="slotProps">
      <div class="flex align-items-center gap-2">
        <span>{{ slotProps.data.ecranDescription }}</span>
      </div>
    </template>
  </DataTable>
  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "RolesGroupeTableModifications",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    this.$root.$refs.breadcrumbComp.activeBallBeat = true;
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch("pilotage/obtenirAuditRolesGroupeAction", {
          cle: this.$route.params.cle
        })
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            this.auditsDataAfficher = res.data
          } else {
            this.auditsDataAfficher = this.formatterAucunAudit();
          }
          this.$root.$refs.breadcrumbComp.activeBallBeat = false;
        })
        .catch((err) => {
          this.$emit("backendError", err);
        })
        .finally(() => {
          this.$emit("isDataLoaded", true);
        })
  },
  data() {
    return {
      rolePrecedent: "",
      roleDescriptionPrecedent: "",
      roleAdministrerPrecedent: "",
      auditsDataAfficher: [],
      justificationFichier: {},
      AUDIT_FIELDS: [
        "modifierLe",
        "justificationTexte",
        "modifierParComplet",
        "ecranDescription",
        "roleNom",
        "roleDescription",
        "roleAdministrer",
        "justificationFichier"
      ],
      FIELD_LABELS: {
        "modifierLe": "Enregistrement en date du ",
        "justificationTexte": "Justification ",
        "modifierParComplet": "Par ",
        "ecranDescription": "Écran ",
        "roleNom": "Rôle ",
        "roleDescription": "Description ",
        "roleAdministrer": "Attr. ",
        "justificationFichier": "Fichier(s) de justification"
      },
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
    nombreModifications() {
      return this.auditsDataAfficher.length;
    },
    tailleListeMultimedia() {
      return this.justificationFichier.length
    },
    listeMultimedia() {
      return this.justificationFichier
    },
  },
  methods: {
    formatAction(action){
      if (action == 0) {
        return "Retiré le :"
      }else {
        return "Ajouté le :"
      }
    },
    afficheRolePrecedent(valeur){
      if (valeur == this.rolePrecedent) {
        return " "
      }else {
        this.roleDescriptionPrecedent = "";
        this.roleAdministrerPrecedent = "";
        this.rolePrecedent = valeur;
        return valeur
      }
    },
    afficheRoleDescriptionPrecedent(valeur){
      if (valeur == this.roleDescriptionPrecedent) {
        return " "
      }else {
        this.roleDescriptionPrecedent = valeur;
        return valeur
      }
    },
    afficheRoleAdministrerPrecedent(valeur){
      if (valeur == this.roleAdministrerPrecedent) {
        return " "
      }else {
        this.roleAdministrerPrecedent = valeur;
        return valeur
      }
    },
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "modifierLe": "",
        "justificationTexte": "",
        "modifierParComplet": "",
        "ecranDescription": "",
        "roleNom": "",
        "roleDescription": "",
        "roleAdministrer": "",
        "justificationFichier": "",
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = {texte: audit[field], isModifie: false,}
      })

      listeAudits.push(auditAffichage);
      return listeAudits;
    },
    onSelect(event){
      var arr = event.donnees;
      const linkSource = `data:application/pdf;base64,${arr}`;
      const downloadLink = document.createElement("a");
      const fileName = event.description;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  },
};
</script>
